export enum supportedLangsEnum {
  EN = 'en',
  DE = 'de'
}
export const supportedLangs = ['en', 'de'];
